export enum DatabaseConnectionType {
  Odbc,
  Npgsql,
}
